import React from 'react';
import {
  LayoutDashboard,
  ClipboardCheck,
  Package,
  FileQuestion,
  BarChart3,
} from 'lucide-react';
import ConsoleLayout from '../shared/ConsoleLayout';

// Staff console menu. Access is enforced by StaffOnlyRoute; every item is visible
// to anyone who reaches this layout.
const MENU = [
  {
    group: null,
    items: [
      { path: '/staff-area', icon: LayoutDashboard, label: 'Dashboard', exact: true },
    ],
  },
  {
    group: 'Orders',
    items: [
      { path: '/staff-area/approvals', icon: ClipboardCheck, label: 'Order Approvals', badge: 'approvals' },
      { path: '/staff-area/orders', icon: Package, label: 'Orders' },
      { path: '/staff-area/inquiries', icon: FileQuestion, label: 'Inquiries (RFQ)', match: ['/staff-area/inquiry/'] },
    ],
  },
  {
    group: 'Insights',
    items: [
      { path: '/staff-area/search-analytics', icon: BarChart3, label: 'Search Analytics' },
    ],
  },
];

const getBrand = () => ({
  title: 'Staff Console',
  subtitle: 'Partner Portal',
  homePath: '/staff-area',
  rootLabel: 'Staff',
});

const StaffLayout = ({ children }) => (
  <ConsoleLayout menu={MENU} getBrand={getBrand}>
    {children}
  </ConsoleLayout>
);

export default StaffLayout;
